<emperor-button
  [uiButtonType]="uiButtonTypes.Text"
  (click)="click($event)"
  (keydown.enter)="click($event)"
>
  <span> EDIT</span><emperor-icon name="pencil_3_1"></emperor-icon>
</emperor-button>
